module.exports = __webpack_public_path__ + "static/img/partner10.bc69ddb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partner10.png
// module id = eLRI
// module chunks = 0